export const LicenceExpiredMessage = (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    }}
  >
    Your licence has expired
    <span>
      <a
        href='https://scileads.chilipiper.com/shared/laura-haldane/sales-demo'
        target='_blank'
        rel='noopener noreferrer'
      >
        Book a call with us here
      </a>{' '}
      to regain your access
    </span>
  </div>
);
